<template>
  <v-snackbar
    v-model="showMessage"
    :color="messageOption.color"
    :timeout="2000"
    top
  >
    <span class="font-weight-black">{{messageOption.contents}}</span>
    <template v-slot:action="{ attrs }">
      <v-btn
        color="white"
        text
        v-bind="attrs"
        @click="showMessage = false"
      >
        Close
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
import store from '@/store'

export default {
  name: 'Notifications',
  computed: {
    showMessage: {
      get() {
        return store.state.message.showMessage
      },
      set(val) {
        store.dispatch('SetShowMessage', val)
      }
    },
    messageOption() {
      return store.state.message.messageOption
    }
  },
  watch: {
    '$store.state.message.messageOption'() {
      this.showMessage = false
      this.$nextTick(() => {
        this.showMessage = true
      })
    }
  }
}
</script>

<style scoped>

</style>
